import { render } from "./FullStatisticsComponent.vue?vue&type=template&id=530d3cbc&scoped=true"
import script from "./FullStatisticsComponent.vue?vue&type=script&lang=js"
export * from "./FullStatisticsComponent.vue?vue&type=script&lang=js"

import "./FullStatisticsComponent.vue?vue&type=style&index=0&id=530d3cbc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-530d3cbc"]])

export default __exports__